"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CLINIC_TIME_PATTERN () {
        return CLINIC_TIME_PATTERN;
    },
    get ClinicTimeSchema () {
        return ClinicTimeSchema;
    },
    get IsoWeekdaySchema () {
        return IsoWeekdaySchema;
    },
    get MINUTES_PER_DAY () {
        return MINUTES_PER_DAY;
    },
    get clinicTimeToMinutes () {
        return clinicTimeToMinutes;
    },
    get findOverlappingWeekday () {
        return findOverlappingWeekday;
    },
    get isoWeekdayOfDate () {
        return isoWeekdayOfDate;
    },
    get mergeTimeIntervals () {
        return mergeTimeIntervals;
    }
});
const _zod = require("zod");
const CLINIC_TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;
const ClinicTimeSchema = _zod.z.string({
    message: 'Time must be text in HH:mm.'
}).regex(CLINIC_TIME_PATTERN, {
    message: 'Time must be HH:mm on a 24-hour clock.'
});
const IsoWeekdaySchema = _zod.z.number({
    message: 'Weekday must be a number.'
}).int({
    message: 'Weekday must be a whole number.'
}).min(1, {
    message: 'Weekday must be 1 (Monday) to 7 (Sunday).'
}).max(7, {
    message: 'Weekday must be 1 (Monday) to 7 (Sunday).'
});
const MINUTES_PER_DAY = 1440;
function clinicTimeToMinutes(time) {
    return Number(time.slice(0, 2)) * 60 + Number(time.slice(3, 5));
}
const CALENDAR_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
function isoWeekdayOfDate(date) {
    const match = CALENDAR_DATE_PATTERN.exec(date);
    if (!match) {
        throw new RangeError('Expected a YYYY-MM-DD calendar date.');
    }
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const utc = new Date(Date.UTC(year, month - 1, day));
    if (utc.getUTCFullYear() !== year || utc.getUTCMonth() !== month - 1 || utc.getUTCDate() !== day) {
        throw new RangeError('Expected a YYYY-MM-DD calendar date.');
    }
    const sundayFirst = utc.getUTCDay();
    if (sundayFirst === 0) {
        return 7;
    }
    return sundayFirst;
}
function findOverlappingWeekday(intervals) {
    const sorted = intervals.map((interval)=>({
            weekday: interval.weekday,
            startMinutes: clinicTimeToMinutes(interval.start),
            endMinutes: clinicTimeToMinutes(interval.end)
        })).sort((a, b)=>a.weekday - b.weekday || a.startMinutes - b.startMinutes);
    for(let i = 1; i < sorted.length; i += 1){
        const previous = sorted[i - 1];
        const current = sorted[i];
        if (current.weekday === previous.weekday && current.startMinutes < previous.endMinutes) {
            return current.weekday;
        }
    }
    return null;
}
function mergeTimeIntervals(intervals) {
    const sorted = intervals.map((interval)=>({
            startMinutes: clinicTimeToMinutes(interval.start),
            endMinutes: clinicTimeToMinutes(interval.end)
        })).sort((a, b)=>a.startMinutes - b.startMinutes);
    const merged = [];
    for (const interval of sorted){
        const last = merged[merged.length - 1];
        if (last && interval.startMinutes <= last.endMinutes) {
            last.endMinutes = Math.max(last.endMinutes, interval.endMinutes);
        } else {
            merged.push({
                ...interval
            });
        }
    }
    return merged;
}
